import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Shield, ArrowRight, ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("ilg_admin_token", data.token);
      localStorage.setItem("ilg_admin_email", data.email);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0D0D0D] grain text-white flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(0,139,139,0.12),_transparent_60%)]" />
      <div className="absolute top-8 left-8">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-white/60 hover:text-[#D4AF37] transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back to Site
        </Link>
      </div>

      <div data-testid="admin-login-card" className="relative w-full max-w-md card-luxury p-10 md:p-12">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-11 h-11 border border-[#D4AF37]/60 flex items-center justify-center">
            <Shield className="w-4 h-4 text-[#D4AF37]" strokeWidth={1.5} />
          </div>
          <div>
            <div className="text-[10px] tracking-[0.32em] text-[#D4AF37]">IMPACT LEGACY</div>
            <div className="text-[10px] tracking-[0.32em] text-white/60">ADMIN PORTAL</div>
          </div>
        </div>

        <h1 className="font-serif text-4xl text-white mb-2">Welcome back.</h1>
        <p className="text-white/55 text-sm mb-10">Sign in to view contact submissions.</p>

        <form onSubmit={submit} className="space-y-8">
          <div>
            <label className="overline mb-3 block">Email</label>
            <input
              type="email"
              data-testid="admin-input-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-luxury"
              required
              autoComplete="email"
            />
          </div>
          <div>
            <label className="overline mb-3 block">Password</label>
            <input
              type="password"
              data-testid="admin-input-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-luxury"
              required
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="btn-primary w-full justify-center disabled:opacity-60"
          >
            {loading ? "Signing in..." : (<>Sign In <ArrowRight className="w-4 h-4" /></>)}
          </button>
        </form>
      </div>
    </div>
  );
}
